import React from 'react';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

const CustomSelectFieldNGX = (props) => {

    return (
        <FormControl
            required={props.required}
            error={hasErrors(props)}
            fullWidth
        >
            <InputLabel id={props.id+"label"}>{props.label}</InputLabel>
            <Select
                labelId={props.id+"label"}
                id={props.id+"select"}
                label={props.label}
                value={props.value}
                inputProps={{
                    name:props.name
                }}
                onChange={
                    (e)=>{
                        props.updaterValue(e.target.value)
                        props.updaterTouch(true)
                    }
                }
                onBlur={
                    ()=>{
                        props.updaterTouch(true)
                    }
                }
            >
                {(!props.touched || props.allowBackToEmpty === true) &&
                <MenuItem 
                    value=""
                    key="keine Auwahl"
                >
                    <em>Keine Auswahl</em>
                </MenuItem>
                }
                {displayEintraege(props.list)}
            </Select>
            <FormHelperText>
                { hasErrors(props) &&
                    errorText(props)
                }
            </FormHelperText>

        </FormControl>
    );
}

const hasErrors = (props) => {
    if (!props.hasOwnProperty("validator") || !props.touched) {
        return false;
    }
    return !props.validator().valid
}

const errorText = (props) => {
    return props.validator().message
}

const displayEintraege = (list) => {
    var arr = []
    list.forEach(
        (obj, index) => arr.push(
            <MenuItem
                key={'smk_'+index}
                value={obj.id}
            >
                {obj.label}
            </MenuItem>
        )
    )

    return arr
  }

export default CustomSelectFieldNGX;
